module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/design-tile-images/design-tile-04-a05e1e6ecd9babc7294a3daea1898e51.jpg";